import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { ieSteps } from '../../../util/IEUtils';
import {
  setActiveStep,
} from '../../../actions/turnkeyOmnibusActions';

const CreateIEHeader = ({
  setActiveStep,
}) => {
  const handleCreateSurvey = () => {
    setActiveStep(ieSteps.CREATE_SURVEY);
  };
  return (
    <header className="ie--header">
      <div className="ie--container">
        <div className="ie--header-button">
          <button
            className="ie--button"
            type="button"
            title="Creat Your Turn-Key Omnibus"
            onClick={() => handleCreateSurvey()}
          >
            Create Your Turn-Key Omnibus
          </button>
        </div>
        <div className="ie--info">
          <p>
            Use Turn-Key Omnibus to quickly unearth the latest consumer behaviors
            via short surveys and
            <br />
            measure the impact of those behaviors by fusing the results with
            MRI-Simmons{"'"} National Studies.
          </p>
        </div>
      </div>
      <div className="ie--breadcrumb">
        <span className="ie--breadcrumb-parent">Omnibus</span>
        <span className="ie--breadcrumb-separator">/</span>
        <span className="ie--breadcrumb-active">Turn-Key Omnibus</span>
      </div>
    </header>
  );
};

CreateIEHeader.propTypes = {
  setActiveStep: PropTypes.func,
};

export default connect(
  null,
  {
    setActiveStep,
  }
)(CreateIEHeader);
